<script>
    import {page} from '$app/stores';
    import {total, meetings_total, url_search_params_string} from '$lib/store.js';
    import {totalString} from '$lib/utils.js';
    import documenten_icon from './documenten.svg';
    import agenda_icon from './agenda.svg';
</script>

<nav id="doc-menu" aria-labelledby="feedmenu">
    <ul style="margin: 0; padding: 0;">
        <li aria-current={$page.url.pathname === "/app" ? "page" : undefined}>
            <a href="/app{$url_search_params_string}">
                <div class="doc-menu-padding">
                    <span>
                        <img src={documenten_icon} width="19.8333" height="19.6" alt=""><br class="d-sm-none"> <span class="doc-menu-span">{totalString($total)}</span><br class="d-sm-none"> Documenten
                    </span>
                </div>
            </a>
        </li>

        <li aria-current={$page.url.pathname === "/app/agenda" ? "page" : undefined}>
            <a href="/app/agenda{$url_search_params_string}">
                <div class="doc-menu-padding">
                    <span>
                        <img src={agenda_icon} width="18" height="19.45" alt=""><br class="d-sm-none"> <span class="doc-menu-span">{totalString($meetings_total)}</span><br class="d-sm-none"> Agenda items
                    </span>
                </div>
            </a>
        </li>
    </ul>
    <p id="feedmenu" class="visually-hidden">Feed menu</p>
</nav>

<style lang="scss">
    #doc-menu {
        padding-left: 0;
        margin-top: 26.6px;
        margin-bottom: 0;

        li {
            display: inline-block;

            &:not(:first-child) {
                margin-left: 64px;
            }

            &[aria-current="page"] {
                border-bottom: 6px solid var(--gold-color);
            }

            &:not([aria-current="page"]):hover {
                border-bottom: 6px solid #e7d5b2;
            }
        }

        .doc-menu-padding {
            padding-bottom: 24.2px;
        }

        span {
            font-size: 16px !important;
            line-height: 22px;
            font-family: var(--font-default);
            font-weight: 600;
        }

        a {
            text-decoration: none;
        }
    }

    .doc-menu-span {
        color: var(--dark-blue-color);
        margin-left: 10px;
    }

    @media (max-width: 575px) {
        #doc-menu {
            padding-left: 0;
            margin-top:25.6px;

            li {
                text-align: center;

                &:not(:first-child) {
                    margin-left: 45px;
                }
            }

            .doc-menu-padding {
                padding-bottom: 9px;
            }

            span {
                margin: 0;
            }

            img {
                margin-bottom: 8.4px;
            }
        }
    }
</style>
